import { useQuery } from '@tanstack/react-query'
import { clientInstance } from 'utils/http-client'

export interface DoorSearchResult {
  item_id: string
  name: string
  domain: string
  latitude: number
  longitude: number
  address: string
  city: string
  state: string
  country: string
  zipcode: string
  chain_id: string
  chain_name: string
  chain_size: number
  type: string
  score: number
}

export interface ChainSearchResult {
  item_id: string
  name: string
  domain: string
  count: number
  type: string
  score: number
}

export interface CombinedSearchResult {
  doors: DoorSearchResult[]
  chains: ChainSearchResult[]
  search_type: string
}

export function useDoorsAndChainsSearch(query: string) {
  return useQuery<CombinedSearchResult>({
    queryKey: ['doors-and-chains-search', query],
    queryFn: async () => {
      const url = `common/search/doors_and_chains/?q=${encodeURIComponent(query)}`
      const client = clientInstance
      const response = await client.get(url)
      return response.data
    },
    enabled: !!query, // Only run if query is provided
  })
}

export function useAllChainsSearch(query: string) {
  return useQuery<ChainSearchResult[]>({
    queryKey: ['all-chains-search', query],
    queryFn: async () => {
      const url = `common/search/chains/?q=${encodeURIComponent(query)}`
      const client = clientInstance
      const response = await client.get(url)
      return response.data
    },
  })
}
